import Icon from './Icon';

export { Icon };



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/index.js